/**
 * OpenAI Model Options
 * Shared constants for OpenAI model selection across the application
 */

export const OPENAI_MODELS = [
  { 
    value: 'gpt-4o', 
    label: 'GPT-4o',
    description: 'Most capable model, best for complex tasks',
    category: 'GPT-4'
  },
  { 
    value: 'gpt-4o-mini', 
    label: 'GPT-4o Mini',
    description: 'Balanced performance and cost',
    category: 'GPT-4'
  },
  { 
    value: 'gpt-4-turbo', 
    label: 'GPT-4 Turbo',
    description: 'Fast and capable',
    category: 'GPT-4'
  },
  { 
    value: 'gpt-4', 
    label: 'GPT-4',
    description: 'Original GPT-4 model',
    category: 'GPT-4'
  },
  { 
    value: 'gpt-4-32k', 
    label: 'GPT-4 32k',
    description: 'Extended context window',
    category: 'GPT-4'
  },
  { 
    value: 'gpt-3.5-turbo', 
    label: 'GPT-3.5 Turbo',
    description: 'Fast and cost-effective',
    category: 'GPT-3.5'
  },
  { 
    value: 'gpt-3.5-turbo-16k', 
    label: 'GPT-3.5 Turbo 16k',
    description: 'Extended context for GPT-3.5',
    category: 'GPT-3.5'
  },
];

// For backward compatibility or special cases
export const LEGACY_MODELS = [
  { 
    value: 'gpt-5.1', 
    label: 'GPT-5.1',
    description: 'Experimental model',
    category: 'Experimental'
  },
];

// Combined list with all models
export const ALL_OPENAI_MODELS = [...OPENAI_MODELS, ...LEGACY_MODELS];

// Helper function to get model by value
export const getModelByValue = (value) => {
  return ALL_OPENAI_MODELS.find(model => model.value === value);
};

// Helper function to get model label
export const getModelLabel = (value) => {
  const model = getModelByValue(value);
  return model ? model.label : value;
};

// Recommended model for directions enhancement
export const RECOMMENDED_MODEL = 'gpt-4o-mini';
